/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
const { string, arrayOf, shape, func } = PropTypes;
import classNames from 'classnames';
import { StarFilled } from '@one-thd/sui-icons';
import { Typography } from '@one-thd/sui-atomic-components';
import { extractRating, getRatingValue } from '../../product-results-helpers';

const RatingRefinement = ({ dimension, onItemSelection, selectedRefinements, secondaryDrawer }) => {

  const [selectedStars, setSelectedStars] = useState(() => {
    return extractRating(getRatingValue(selectedRefinements, secondaryDrawer));
  });

  useEffect(() => {
    const rating = getRatingValue(selectedRefinements, secondaryDrawer);
    setSelectedStars(extractRating(rating));
  }, [selectedRefinements, secondaryDrawer]);

  const onStarItemSelection = (index) => {
    const selectedIndex = index + 1;
    const isDeselecting = selectedIndex === selectedStars;

    // Handle deselection
    if (isDeselecting) {
      setSelectedStars(0);
      onItemSelection({
        dimension,
        ...(secondaryDrawer && { radio: true })
      });
      return;
    }
    const refinement = {
      ...dimension.refinements.find(
        (item) => item.label.includes(selectedIndex.toString())
      )
    };

    // Handle selection
    setSelectedStars(selectedIndex);
    onItemSelection({
      dimension,
      refinement,
      ...(secondaryDrawer && { radio: true })
    });
  };

  const getRatingMessage = () => {
    if (selectedStars === 5) {
      return '5 stars';
    }
    if (selectedStars > 0) {
      return `${selectedStars} stars and up`;
    }
    return 'Please choose a rating';
  };

  return (
    <section
      className={classNames(
        'sui-cursor-pointer sui-text-center',
        {
          'sui-mt-1': !secondaryDrawer,
          'sui-mb-2': secondaryDrawer
        }
      )}
      data-testid="rating-refinement"
    >
      {(() => {
        const stars = [];
        for (let index = 0; index < 5; index += 1) {
          const rating = index + 1;
          const refinement = dimension.refinements.find(
            (item) => item.label.includes(rating.toString())
          );
          const starText = rating === 1 ? '' : 's';
          const ratingDescription = rating === 5 ? '5 stars' : `${rating} star${starText} and up`;
          const ariaLabel = `Filter by ${ratingDescription}`;
          stars.push(
            <section
              className="sui-mr-3 sui-inline-block"
              key={index}
              onClick={() => onStarItemSelection(index)}
            >
              {index < selectedStars
                ? <StarFilled size="large" color="brand" />
                : <StarFilled size="large" color="subtle" />}
              {/* SEO-friendly hidden link - Required for SEO significance.
               Reach out to SEO team if wanting to change */}
              <a
                href={refinement?.url}
                className="sui-hidden"
                aria-label={ariaLabel}
              >
                {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
                <h3>{refinement?.label}</h3>
              </a>
            </section>
          );
        }
        return stars;
      })()}
      {/* Display text based on the number of selected stars */}
      <div className="sui-mt-3">
        <Typography>
          {getRatingMessage()}
        </Typography>
      </div>
    </section>
  );
};

RatingRefinement.displayName = 'RatingRefinement';
RatingRefinement.propTypes = {
  dimension: shape({
    dimensionId: string,
    label: string,
    refinements: arrayOf(
      shape({})
    )
  }).isRequired,
  onItemSelection: func.isRequired,
  selectedRefinements: arrayOf(shape({})).isRequired,
  secondaryDrawer: PropTypes.bool
};

RatingRefinement.defaultProps = {
  secondaryDrawer: false
};

export { RatingRefinement };